export const USE_API =
  process.env.VUE_APP_USE_API !== 'false' &&
  process.env.VUE_APP_USE_API !== '0'
export const API_BASE = process.env.VUE_APP_API_BASE || '/api'
